interface Lookup {
  [key: string]: string;
}

export const optionsToLookup = (options: string[]) =>
  options.reduce((acc: Lookup, el: string) => {
    acc[el] = el;
    return acc;
  }, {} as Lookup);
